<template>
  <div style="margin: 0 50px">
    <el-form style="margin-right: 25px" :model="addFamilyForm" :rules="addFamilyRules" ref="addFamilyForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="成员姓名" prop="name">
        <el-input v-model="addFamilyForm.name"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="name">
        <el-input type="number" v-model="addFamilyForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="小程序账号" prop="">
        <el-radio-group v-model="addFamilyForm.is_open_applet">
          <el-radio :label="0">不开通</el-radio>
          <el-radio :label="1">开通</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入关系备注" v-model="addFamilyForm.remark"></el-input>
      </el-form-item>
    </el-form>
    <div>
      <el-row style="margin: 0 100px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeFamily()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('addFamilyForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import {addfamilyperson, updatefamilyperson} from '../../../api/serviceObject'

export default {
  name: 'addContact',
  model: {
    prop: 'addContactShow',
    event: 'change'
  },
  props: {
    contactObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      addFamilyForm: {
        id: 0,
        name: '',
        phone: '',
        remark: '',
        pid: '',
        hid: '',
        is_open_applet: 0
      },
      addFamilyRules: {
        name: [
          { required: true, message: '请输入成员姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.addFamilyForm.pid = this.contactObj.personRow.id
    this.addFamilyForm.hid = this.contactObj.personRow.homeid
    if (!this.contactObj.isAdd) {
      this.addFamilyForm = {
        id: this.contactObj.contactRow.id,
        name: this.contactObj.contactRow.name,
        phone: this.contactObj.contactRow.phone,
        remark: this.contactObj.contactRow.remark,
        pid: this.contactObj.personRow.id,
        hid: this.contactObj.personRow.homeid
      }
    }
  },
  methods: {
    closeFamily () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addFamilyForm.id === 0) {
            addfamilyperson(this.addFamilyForm).then(res => {
              this.$notify({
                title: '成功',
                message: '成功新建联系人',
                type: 'success',
                duration: 2000
              })
              this.golobleObject.updateFamilyNew()
              this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '新建联系人失败'
              })
            })
          } else {
            updatefamilyperson(this.addFamilyForm).then(res => {
              this.$notify({
                title: '成功',
                message: '成功编辑联系人',
                type: 'success',
                duration: 2000
              })
              this.golobleObject.updateFamilyNew()
              this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '编辑联系人失败'
              })
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/addContact.vue